'use client';

/* eslint-disable react/jsx-key */

import dynamic from 'next/dynamic';

import { useDevice } from '@contexts/device';
import { FooterViewModel, SocialMediaIconsViewModel } from '@api/v3';

import { Wrapper } from './FooterStyle';

const MobileFooter = dynamic(() => import('./MobileFooter/MobileFooter'));
const DesktopFooter = dynamic(() => import('./DesktopFooter'));

interface FooterProps {
  isHomepage?: boolean;
  footerData?: FooterViewModel;
  socialMediaIconsData?: SocialMediaIconsViewModel[];
}

const Footer = ({
  isHomepage,
  footerData,
  socialMediaIconsData,
}: FooterProps) => {
  const { isDesktop } = useDevice();
  return (
    <footer>
      <Wrapper>
        {isDesktop ? (
          <DesktopFooter
            data={footerData}
            socialMedia={socialMediaIconsData}
            isHomepage={isHomepage}
          />
        ) : (
          <MobileFooter data={footerData} isHomepage={isHomepage} />
        )}
      </Wrapper>
    </footer>
  );
};

export default Footer;
